import { setAreaGrouping } from "@/features/dataTableSlice";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useDispatch, useSelector } from "react-redux";
export function AreaSelection(props) {
  const areaGrouping = useSelector((state) => state.dataTable.areaGrouping);
  const dispatch = useDispatch();

  const handleTypeGroupChange = (e) => {
    dispatch(setAreaGrouping({ value: e.target.value }));
  };
  return (
    <FormControl sx={{ m: 1, width: 100 }}>
      <InputLabel id="areaGrouping-select-label">分類</InputLabel>
      <Select
        labelId="areaGrouping-select-label"
        id="areaGrouping-select"
        value={areaGrouping}
        label="area"
        onChange={handleTypeGroupChange}
      >
        <MenuItem value={"shop"}>店鋪</MenuItem>
        <MenuItem value={"area"}>地區</MenuItem>
        <MenuItem value={"district"}>區域</MenuItem>
        <MenuItem value={"nature"}>Profile</MenuItem>
      </Select>
    </FormControl>
  );
}
